/*
 * View for categories
 *
 */

define(["marionette", "./template/categoriesTemplate.html"], function (
  Marionette,
  CategoriesTemplate,
) {
  var CategoriesView = {};

  CategoriesView.categoriesLayout = Marionette.Layout.extend({
    template: CategoriesTemplate,
    regions: {
      categoryList: "#categoryList",
      categoryValue: "#categoryValue",
    },
  });

  return CategoriesView;
});
